function validateForm(form) {
  const formFields = Object.keys(form);
  const formIsValid = formFields.reduce((isValid, fieldKey) => {
    return isValid && form[fieldKey].isValid;
  }, true);
  return formIsValid;
}

export default validateForm;



// WEBPACK FOOTER //
// ./src/common/formValidation/validateForm.js